"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Requests AND stores flag configurations
class ConfigurationRequestor {
    constructor(httpClient, flagConfigurationStore, banditVariationConfigurationStore, banditModelConfigurationStore) {
        this.httpClient = httpClient;
        this.flagConfigurationStore = flagConfigurationStore;
        this.banditVariationConfigurationStore = banditVariationConfigurationStore;
        this.banditModelConfigurationStore = banditModelConfigurationStore;
    }
    async fetchAndStoreConfigurations() {
        var _a;
        const configResponse = await this.httpClient.getUniversalFlagConfiguration();
        if (!(configResponse === null || configResponse === void 0 ? void 0 : configResponse.flags)) {
            return;
        }
        await this.hydrateConfigurationStore(this.flagConfigurationStore, {
            entries: configResponse.flags,
            environment: configResponse.environment,
            createdAt: configResponse.createdAt,
        });
        const flagsHaveBandits = Object.keys((_a = configResponse.bandits) !== null && _a !== void 0 ? _a : {}).length > 0;
        const banditStoresProvided = Boolean(this.banditVariationConfigurationStore && this.banditModelConfigurationStore);
        if (flagsHaveBandits && banditStoresProvided) {
            // Map bandit flag associations by flag key for quick lookup (instead of bandit key as provided by the UFC)
            const banditVariations = this.indexBanditVariationsByFlagKey(configResponse.bandits);
            await this.hydrateConfigurationStore(this.banditVariationConfigurationStore, {
                entries: banditVariations,
                environment: configResponse.environment,
                createdAt: configResponse.createdAt,
            });
            // TODO: different polling intervals for bandit parameters
            const banditResponse = await this.httpClient.getBanditParameters();
            if (banditResponse === null || banditResponse === void 0 ? void 0 : banditResponse.bandits) {
                if (!this.banditModelConfigurationStore) {
                    throw new Error('Bandit parameters fetched but no bandit configuration store provided');
                }
                await this.hydrateConfigurationStore(this.banditModelConfigurationStore, {
                    entries: banditResponse.bandits,
                    environment: configResponse.environment,
                    createdAt: configResponse.createdAt,
                });
            }
        }
    }
    async hydrateConfigurationStore(configurationStore, response) {
        if (configurationStore) {
            const didUpdate = await configurationStore.setEntries(response.entries);
            if (didUpdate) {
                configurationStore.setEnvironment(response.environment);
                configurationStore.setConfigFetchedAt(new Date().toISOString());
                configurationStore.setConfigPublishedAt(response.createdAt);
            }
        }
    }
    indexBanditVariationsByFlagKey(banditVariationsByBanditKey) {
        const banditVariationsByFlagKey = {};
        Object.values(banditVariationsByBanditKey).forEach((banditVariations) => {
            banditVariations.forEach((banditVariation) => {
                let banditVariations = banditVariationsByFlagKey[banditVariation.flagKey];
                if (!banditVariations) {
                    banditVariations = [];
                    banditVariationsByFlagKey[banditVariation.flagKey] = banditVariations;
                }
                banditVariations.push(banditVariation);
            });
        });
        return banditVariationsByFlagKey;
    }
}
exports.default = ConfigurationRequestor;
//# sourceMappingURL=configuration-requestor.js.map